(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-department-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fs-hero-slider')) {
  customElements.define('fs-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.autoTimer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.contents = Array.from(this.querySelectorAll('[data-room-content]'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false'));
      this.requestedIndex = this.index;
      this.requestVersion = 0;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motionQuery.matches;
      this.inView = false;
      this.hovered = false;
      this.pointerHeld = false;
      this.playButton = this.querySelector('[data-autoplay]');
      this.motionQuery.addEventListener('change', () => {
        this.finishMotion();
        if (this.motionQuery.matches) this.userPaused = true;
        this.scheduleAutoplay();
      }, options);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-autoplay]')) {
          this.userPaused = !this.userPaused;
          this.scheduleAutoplay();
          return;
        }
        const control = event.target.closest('[data-step], [data-go]');
        if (!control) return;
        this.show(control.hasAttribute('data-go') ? Number(control.dataset.go) : this.requestedIndex + Number(control.dataset.step));
      }, options);
      const stage = this.querySelector('.fs-hero-room__slides');
      this.stage = stage;
      stage.addEventListener('focusin', () => this.finishMotion(), options);
      this.addEventListener('focusin', () => this.scheduleAutoplay(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.scheduleAutoplay()), options);
      this.addEventListener('toggle', () => this.scheduleAutoplay(), { ...options, capture: true });
      stage.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.scheduleAutoplay(); }
      }, options);
      stage.addEventListener('pointerleave', () => { this.hovered = false; this.scheduleAutoplay(); }, options);
      this.addEventListener('pointerdown', () => { this.pointerHeld = true; this.scheduleAutoplay(); }, options);
      for (const type of ['pointerup', 'pointercancel']) {
        window.addEventListener(type, () => { this.pointerHeld = false; this.scheduleAutoplay(); }, options);
      }
      document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        this.scheduleAutoplay();
      }, { threshold: [0, 0.35] });
      this.observer.observe(stage);
      stage.addEventListener('pointerdown', (event) => {
        this.finishMotion();
        this.start = null;
        if (event.pointerType !== 'touch' || event.target.closest('button, a, [popover]')) return;
        this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, options);
      stage.addEventListener('pointerup', (event) => {
        const start = this.start;
        this.start = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.requestedIndex + (dx < 0 ? 1 : -1));
      }, options);
      stage.addEventListener('pointercancel', () => { this.start = null; }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const slide = this.slides.findIndex((item) => item.dataset.blockId === event.detail.blockId);
        if (slide >= 0) this.show(slide);
      }, options);
      const nextImage = this.slides[(this.index + 1) % this.slides.length]?.querySelector('picture img');
      if (nextImage) nextImage.loading = 'eager';
      this.scheduleAutoplay();
    }
    canAutoplay() {
      const focused = this.contains(document.activeElement) && document.activeElement !== this.playButton &&
        document.activeElement.matches(':focus-visible');
      return this.isConnected && this.slides.length > 1 && !this.userPaused && this.inView &&
        !this.hovered && !this.pointerHeld && !focused && !document.hidden && !window.Shopify?.designMode &&
        !this.querySelector('.fs-product-point__panel:popover-open');
    }
    scheduleAutoplay() {
      clearTimeout(this.autoTimer);
      if (this.playButton) {
        this.playButton.setAttribute('aria-pressed', String(this.userPaused));
        this.playButton.setAttribute('aria-label', this.userPaused ? this.playButton.dataset.playLabel : this.playButton.dataset.pauseLabel);
      }
      const running = this.canAutoplay();
      this.dataset.autoplayState = running ? 'running' : 'paused';
      if (running) this.autoTimer = setTimeout(() => {
        if (this.canAutoplay()) this.show(this.index + 1, true);
      }, 5000);
    }
    finishMotion() {
      clearTimeout(this.motionTimer);
      this.slides?.forEach((slide) => slide.classList.remove('is-entering', 'is-leaving'));
      this.contents?.forEach((content) => content.classList.remove('is-arriving'));
    }
    async show(next, automatic = false) {
      clearTimeout(this.autoTimer);
      if (!this.slides.length) return;
      const index = (next + this.slides.length) % this.slides.length;
      const direction = next < this.requestedIndex ? 'previous' : 'next';
      this.requestedIndex = index;
      const version = ++this.requestVersion;
      if (index === this.index) { this.scheduleAutoplay(); return; }
      const incoming = this.slides[index];
      const image = incoming.querySelector('picture img');
      if (image) {
        image.loading = 'eager';
        try { await image.decode(); } catch {}
      }
      if (version !== this.requestVersion || !this.isConnected) return;
      if (automatic && !this.canAutoplay()) {
        this.requestedIndex = this.index;
        this.scheduleAutoplay();
        return;
      }
      this.finishMotion();
      this.querySelectorAll('.fs-product-point__panel:popover-open').forEach((panel) => panel.hidePopover());
      const previous = this.slides[this.index];
      if (previous.contains(document.activeElement)) this.dots[index]?.focus({ preventScroll: true });
      this.stage.dataset.direction = direction;
      const apply = () => {
        if (version !== this.requestVersion) return;
        this.slides.forEach((slide, i) => {
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        this.contents.forEach((content, i) => { content.hidden = i !== index; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        this.index = index;
        const status = this.querySelector('.fs-hero-room__status');
        status.setAttribute('aria-live', automatic ? 'off' : 'polite');
        status.textContent = incoming.getAttribute('aria-label') + ' — ' + (index + 1) + ' / ' + this.slides.length;
        if (!this.motionQuery.matches) this.contents[index]?.classList.add('is-arriving');
      };
      if (this.motionQuery.matches) {
        apply();
      } else {
        apply();
        previous.classList.add('is-leaving');
        incoming.classList.add('is-entering');
        this.motionTimer = setTimeout(() => this.finishMotion(), 850);
      }
      const nextImage = this.slides[(index + 1) % this.slides.length].querySelector('picture img');
      if (nextImage) nextImage.loading = 'eager';
      this.scheduleAutoplay();
    }
    disconnectedCallback() {
      this.requestVersion++;
      this.finishMotion();
      clearTimeout(this.autoTimer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-hero-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fs-hero-slider')) {
  customElements.define('fs-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.autoTimer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.contents = Array.from(this.querySelectorAll('[data-room-content]'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false'));
      this.requestedIndex = this.index;
      this.requestVersion = 0;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motionQuery.matches;
      this.inView = false;
      this.hovered = false;
      this.pointerHeld = false;
      this.playButton = this.querySelector('[data-autoplay]');
      this.motionQuery.addEventListener('change', () => {
        this.finishMotion();
        if (this.motionQuery.matches) this.userPaused = true;
        this.scheduleAutoplay();
      }, options);
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-autoplay]')) {
          this.userPaused = !this.userPaused;
          this.scheduleAutoplay();
          return;
        }
        const control = event.target.closest('[data-step], [data-go]');
        if (!control) return;
        this.show(control.hasAttribute('data-go') ? Number(control.dataset.go) : this.requestedIndex + Number(control.dataset.step));
      }, options);
      const stage = this.querySelector('.fs-hero-room__slides');
      this.stage = stage;
      stage.addEventListener('focusin', () => this.finishMotion(), options);
      this.addEventListener('focusin', () => this.scheduleAutoplay(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.scheduleAutoplay()), options);
      this.addEventListener('toggle', () => this.scheduleAutoplay(), { ...options, capture: true });
      stage.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.scheduleAutoplay(); }
      }, options);
      stage.addEventListener('pointerleave', () => { this.hovered = false; this.scheduleAutoplay(); }, options);
      this.addEventListener('pointerdown', () => { this.pointerHeld = true; this.scheduleAutoplay(); }, options);
      for (const type of ['pointerup', 'pointercancel']) {
        window.addEventListener(type, () => { this.pointerHeld = false; this.scheduleAutoplay(); }, options);
      }
      document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
        this.scheduleAutoplay();
      }, { threshold: [0, 0.35] });
      this.observer.observe(stage);
      stage.addEventListener('pointerdown', (event) => {
        this.finishMotion();
        this.start = null;
        if (event.pointerType !== 'touch' || event.target.closest('button, a, [popover]')) return;
        this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, options);
      stage.addEventListener('pointerup', (event) => {
        const start = this.start;
        this.start = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.requestedIndex + (dx < 0 ? 1 : -1));
      }, options);
      stage.addEventListener('pointercancel', () => { this.start = null; }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const slide = this.slides.findIndex((item) => item.dataset.blockId === event.detail.blockId);
        if (slide >= 0) this.show(slide);
      }, options);
      const nextImage = this.slides[(this.index + 1) % this.slides.length]?.querySelector('picture img');
      if (nextImage) nextImage.loading = 'eager';
      this.scheduleAutoplay();
    }
    canAutoplay() {
      const focused = this.contains(document.activeElement) && document.activeElement !== this.playButton &&
        document.activeElement.matches(':focus-visible');
      return this.isConnected && this.slides.length > 1 && !this.userPaused && this.inView &&
        !this.hovered && !this.pointerHeld && !focused && !document.hidden && !window.Shopify?.designMode &&
        !this.querySelector('.fs-product-point__panel:popover-open');
    }
    scheduleAutoplay() {
      clearTimeout(this.autoTimer);
      if (this.playButton) {
        this.playButton.setAttribute('aria-pressed', String(this.userPaused));
        this.playButton.setAttribute('aria-label', this.userPaused ? this.playButton.dataset.playLabel : this.playButton.dataset.pauseLabel);
      }
      const running = this.canAutoplay();
      this.dataset.autoplayState = running ? 'running' : 'paused';
      if (running) this.autoTimer = setTimeout(() => {
        if (this.canAutoplay()) this.show(this.index + 1, true);
      }, 5000);
    }
    finishMotion() {
      clearTimeout(this.motionTimer);
      this.slides?.forEach((slide) => slide.classList.remove('is-entering', 'is-leaving'));
      this.contents?.forEach((content) => content.classList.remove('is-arriving'));
    }
    async show(next, automatic = false) {
      clearTimeout(this.autoTimer);
      if (!this.slides.length) return;
      const index = (next + this.slides.length) % this.slides.length;
      const direction = next < this.requestedIndex ? 'previous' : 'next';
      this.requestedIndex = index;
      const version = ++this.requestVersion;
      if (index === this.index) { this.scheduleAutoplay(); return; }
      const incoming = this.slides[index];
      const image = incoming.querySelector('picture img');
      if (image) {
        image.loading = 'eager';
        try { await image.decode(); } catch {}
      }
      if (version !== this.requestVersion || !this.isConnected) return;
      if (automatic && !this.canAutoplay()) {
        this.requestedIndex = this.index;
        this.scheduleAutoplay();
        return;
      }
      this.finishMotion();
      this.querySelectorAll('.fs-product-point__panel:popover-open').forEach((panel) => panel.hidePopover());
      const previous = this.slides[this.index];
      if (previous.contains(document.activeElement)) this.dots[index]?.focus({ preventScroll: true });
      this.stage.dataset.direction = direction;
      const apply = () => {
        if (version !== this.requestVersion) return;
        this.slides.forEach((slide, i) => {
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        this.contents.forEach((content, i) => { content.hidden = i !== index; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        this.index = index;
        const status = this.querySelector('.fs-hero-room__status');
        status.setAttribute('aria-live', automatic ? 'off' : 'polite');
        status.textContent = incoming.getAttribute('aria-label') + ' — ' + (index + 1) + ' / ' + this.slides.length;
        if (!this.motionQuery.matches) this.contents[index]?.classList.add('is-arriving');
      };
      if (this.motionQuery.matches) {
        apply();
      } else {
        apply();
        previous.classList.add('is-leaving');
        incoming.classList.add('is-entering');
        this.motionTimer = setTimeout(() => this.finishMotion(), 850);
      }
      const nextImage = this.slides[(index + 1) % this.slides.length].querySelector('picture img');
      if (nextImage) nextImage.loading = 'eager';
      this.scheduleAutoplay();
    }
    disconnectedCallback() {
      this.requestVersion++;
      this.finishMotion();
      clearTimeout(this.autoTimer);
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-store-locations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fs-store-explorer')) {
  customElements.define('fs-store-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.tabs = Array.from(this.querySelectorAll('[data-store-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-store-panel]'));
      this.stage = this.querySelector('[data-store-stage]');
      this.dialog = this.querySelector('[data-store-lightbox]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionButton = this.querySelector('[data-store-motion]');
      this.requestNumber = 0;
      this.userPaused = false;
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.querySelector('[data-store-tabs]').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', event => {
          event.preventDefault();
          this.select(index, true);
        }, options);
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ') {
            event.preventDefault();
            this.select(index, true);
            return;
          } else return;
          event.preventDefault();
          this.tabs[next].focus();
          this.select(next, true);
        }, options);
      });
      this.querySelectorAll('[data-store-step]').forEach(button => {
        button.addEventListener('click', () => this.select((this.activeIndex + Number(button.dataset.storeStep) + this.tabs.length) % this.tabs.length, true), options);
      });
      this.querySelectorAll('[data-store-jump]').forEach(link => {
        link.addEventListener('click', async event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === link.dataset.storeJump);
          if (index < 0) return;
          event.preventDefault();
          await this.select(index, true);
          if (!this.isConnected) return;
          this.panels[index].focus({preventScroll: true});
          this.stage.scrollIntoView({behavior: this.motion.matches || this.userPaused ? 'instant' : 'smooth', block: 'start'});
        }, options);
      });
      this.querySelectorAll('[data-store-enlarge]').forEach(link => {
        link.addEventListener('click', event => {
          if (!this.dialog.showModal) return;
          event.preventDefault();
          const panel = link.closest('[data-store-panel]');
          const original = panel.querySelector('.fs-locator__photo');
          const photo = document.createElement('img');
          photo.src = link.href;
          photo.alt = original.alt;
          photo.width = original.naturalWidth || original.width;
          photo.height = original.naturalHeight || original.height;
          this.querySelector('[data-store-photo-mount]').replaceChildren(photo);
          this.querySelector('[data-store-photo-title]').textContent = panel.dataset.title;
          this.photoOpener = link;
          this.dialog.showModal();
        }, options);
      });
      this.querySelector('[data-store-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.photoOpener?.focus({preventScroll: true}), options);
      this.querySelectorAll('[data-store-swipe]').forEach(visual => {
        visual.addEventListener('pointerdown', event => {
          this.swipe = event.pointerType === 'touch' && !event.target.closest('a,button') ? {x: event.clientX, y: event.clientY, id: event.pointerId} : null;
        }, options);
        visual.addEventListener('pointerup', event => {
          if (!this.swipe || this.swipe.id !== event.pointerId) return;
          const dx = event.clientX - this.swipe.x;
          const dy = event.clientY - this.swipe.y;
          this.swipe = null;
          if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select((this.activeIndex + (dx < 0 ? 1 : -1) + this.tabs.length) % this.tabs.length, true);
        }, options);
        visual.addEventListener('pointercancel', () => { this.swipe = null; }, options);
      });
      this.motionButton.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.syncMotion();
      }, options);
      this.motion.addEventListener('change', () => this.syncMotion(), options);
      this.syncMotion();
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index, false);
      }, options);
      window.addEventListener('hashchange', () => {
        const index = this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
        if (index >= 0) this.select(index, false);
      }, options);
      const initialIndex = this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
      this.apply(initialIndex >= 0 ? initialIndex : 0);
      this.classList.add('is-ready');
      this.querySelector('[data-store-controls]').hidden = false;
      if ('IntersectionObserver' in window && !this.motion.matches) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              this.observer.unobserve(entry.target);
            }
          });
        }, {threshold: 0.08});
        this.querySelectorAll('[data-store-reveal]').forEach(item => {
          if (item.getBoundingClientRect().top < window.innerHeight) {
            item.classList.add('is-revealed');
          } else {
            item.classList.add('will-reveal');
            this.observer.observe(item);
          }
        });
      }
    }
    syncMotion() {
      const paused = this.motion.matches || this.userPaused;
      this.dataset.motionPaused = String(paused);
      this.motionButton.hidden = this.motion.matches;
      this.motionButton.setAttribute('aria-pressed', String(this.userPaused));
      this.motionButton.textContent = this.userPaused ? this.motionButton.dataset.playLabel : this.motionButton.dataset.pauseLabel;
      if (paused) {
        this.transition?.skipTransition();
        this.querySelectorAll('.will-reveal').forEach(item => item.classList.add('is-revealed'));
      }
    }
    apply(index) {
      this.activeIndex = index;
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      this.dataset.activeLocation = this.panels[index].dataset.blockId;
      this.querySelector('[data-store-count]').textContent = String(index + 1).padStart(2, '0');
      this.querySelector('[data-store-current]').textContent = this.panels[index].dataset.title;
    }
    async select(index, updateUrl) {
      const requestNumber = ++this.requestNumber;
      if (index === this.activeIndex) {
        this.stage.removeAttribute('aria-busy');
        this.transition?.skipTransition();
        return;
      }
      const photo = this.panels[index].querySelector('.fs-locator__photo');
      if (photo && !photo.complete && photo.decode) {
        this.stage.setAttribute('aria-busy', 'true');
        await photo.decode().catch(() => {});
      }
      if (requestNumber !== this.requestNumber || !this.isConnected) return;
      this.stage.removeAttribute('aria-busy');
      this.transition?.skipTransition();
      const update = () => {
        if (requestNumber !== this.requestNumber || !this.isConnected) return;
        this.apply(index);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.hash = this.panels[index].id;
          window.history.replaceState(window.history.state, '', url);
        }
      };
      if (!this.motion.matches && !this.userPaused && document.startViewTransition) {
        this.stage.style.viewTransitionName = 'fs-store-scene';
        this.transition = document.startViewTransition(update);
        this.transition.ready.catch(() => {});
        const current = this.transition;
        try { await current.finished; } catch (error) {} finally {
          if (this.transition === current) {
            this.stage.style.viewTransitionName = '';
            this.transition = null;
          }
        }
      } else {
        update();
        if (!this.motion.matches && !this.userPaused) this.panels[index].animate([{opacity: 0, transform: 'translateY(16px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 650, easing: 'cubic-bezier(.22,1,.36,1)'});
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.transition?.skipTransition();
      if (this.dialog?.open) this.dialog.close();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
